import { render, staticRenderFns } from "./upfile.vue?vue&type=template&id=e2552f58&scoped=true"
import script from "./upfile.vue?vue&type=script&lang=js"
export * from "./upfile.vue?vue&type=script&lang=js"
import style0 from "./upfile.vue?vue&type=style&index=0&id=e2552f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2552f58",
  null
  
)

export default component.exports